(function CruiseBookingSummary($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(/^CruiseBooking\//, function onload()
		{
			// open modal with promotion details
			$('.result-amex-mr-details').click(function showAmexMembershipRewardsDetails(e) {
				var promo_id = $(this).data('amex-mr-id');
				var $modal   = $('.modal');

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading AMEX Membership Rewards Details...');

				Adzuki.Ajax.get('/CruiseSearch/mrPromotionDetails/' + promo_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('AMEX Membership Rewards Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		}, false);
	});
}(jQuery, window.Adzuki || {}));
